import React from 'react';

import {IContentfulBoldProps} from './IContentfulBold';

const ContentfulBold = ({children}: IContentfulBoldProps) => {
	return <span className="bold">{children}</span>;
};

export default ContentfulBold;
